// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"AnnotatedMarkup_paragraph__IUT9l"};